module.exports = __webpack_public_path__ + "static/media/preload-white.292b97e5.gif";